module.exports = __webpack_public_path__ + "static/img/title-pt.12cea01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-pt.png
// module id = dwxN
// module chunks = 1